import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@contexts/AuthContext';
import HouseholdGate from './HouseholdGate';

export default function ProtectedRoute({ children }: { children: JSX.Element }) {
  const { session, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex h-screen items-center justify-center text-gray-500">
        Loading…
      </div>
    );
  }

  if (!session) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  // HouseholdGate handles three states: loading, no-household-yet (shows
  // an inline create form), and ready (renders children). Wrapping here
  // means every authed route gets the same gate without per-page wiring.
  return <HouseholdGate>{children}</HouseholdGate>;
}
